import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "counter"]

  static values = {
    countdown: { type: Boolean, default: false }
  }

  connect() {
    this.inputTarget.addEventListener("input", this.update.bind(this))

    this.update()
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.update)
  }

  update() {
    if (this.maxLength < 0) return

    this.element.classList.remove("warning", "error")

    const count = this.count()
    if (this.hasCounterTarget) this.counterTarget.innerHTML = count

    if (count >= this.maxLength) {
      this.element.classList.add("error")
    } else if (count >= this.maxLength * 0.8) {
      this.element.classList.add("warning")
    }
  }

  count() {
    let value = this.inputTarget.value.length

    if (this.countdownValue) {
      if (this.maxLength < 0) {
        console.error("brak maxLength")
      }

      value = Math.max(this.maxLength - value, 0)
    }

    return value
  }

  get maxLength() {
    return this.inputTarget.maxLength
  }
}
